import usePrivateAxios from '@/common/api/usePrivateAxios';
import { ErrorResponse } from '@/common/types/errorResponse';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { MaintenanceEstablishmentChoiceAuctionEntryProposalData } from '../types/auctionEntryProposal.type';

interface UseMaintenanceEstablishmentChoiceAuctionEntryProposalProps {
  auctionEntryProposalId: string | undefined;
  options?: Partial<Omit<UseQueryOptions<
    { data: { data: MaintenanceEstablishmentChoiceAuctionEntryProposalData; } },
    ErrorResponse,
    MaintenanceEstablishmentChoiceAuctionEntryProposalData
  >, 'queryKey' | 'queryFn'>>;
}

export const useMaintenanceEstablishmentChoiceAuctionEntryProposal = ({
  auctionEntryProposalId,
  options,
}: UseMaintenanceEstablishmentChoiceAuctionEntryProposalProps) => {
  const privateAxios = usePrivateAxios();

  return useQuery({
    enabled: !!auctionEntryProposalId,
    queryKey: ['maintenanceEstablishmentChoiceAuctionEntryProposal', auctionEntryProposalId],
    queryFn: () => {
      return privateAxios.get(`/maintenance/establishment_choice/auction_entry_proposals/${auctionEntryProposalId}`);
    },
    select: (response) => response?.data?.data,
    ...options
  });
}
